var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "booking-section",
    {
      attrs: {
        id: "flight-details",
        title: _vm.$t("booking.sectionTitles.flightDetails"),
        collapsed: _vm.moduleCollapsed,
        contentClass: ""
      }
    },
    [
      _vm.loaded
        ? _c("div", [
            _c("div", {
              staticClass: "booking-element",
              domProps: { innerHTML: _vm._s(_vm.result.prices_table) }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "booking-element" }, [
              _c("div", {
                domProps: { innerHTML: _vm._s(_vm.result.flight_plan) }
              }),
              _vm._v(" "),
              _c("table", { staticClass: "booking-prices" }, [
                _c("tfoot", { staticClass: "flight_details__footer" }, [
                  _c("tr", [
                    _c("td", { attrs: { colspan: "7" } }, [
                      _c("div", { staticClass: "spacer" }, [
                        _c("b", [
                          _vm._v(
                            "aktueller Gesamtpreis inkl. Flug: " +
                              _vm._s(_vm.resultData[0].total)
                          )
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c("div", { staticClass: "spacer" }, [
                          _c("a", { staticClass: "metainfo small" }, [
                            _vm._v(
                              "Klicken Sie hier um Details zu den enthaltenen Steuern und Gebühren zu erhalten"
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "cta",
                            on: { click: _vm.sendBookingProceed }
                          },
                          [_vm._v("Bestätigen und fortfahren")]
                        )
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        : _c("loader", {
            attrs: {
              title: "Flugdetails werden geladen",
              details: "Einen Moment bitte"
            }
          }),
      _vm._v(" "),
      _vm.result &&
      _vm.result.segment_fares &&
      _vm.result.segment_fares.length > 0
        ? _c(
            "div",
            {
              staticClass: "reveal",
              attrs: { id: "fare-rules-overlay", "data-reveal": "" }
            },
            [
              _c(
                "div",
                { staticClass: "inner" },
                [
                  _vm.rulesLoading
                    ? _c("loader", {
                        attrs: {
                          title: "Tarifdetails werden geladen",
                          details: "Einen Moment bitte"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "rule-tabs" },
                    _vm._l(_vm.result.segment_fares, function(seg, i) {
                      return _c(
                        "div",
                        {
                          class:
                            "rule-tab " +
                            (i == _vm.currentRule ? "active" : ""),
                          on: {
                            click: function($event) {
                              return _vm.checkRules(i)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n          " + _vm._s(seg.route) + "\n        "
                          )
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.fareRules, function(rule, i) {
                    return _c("div", { staticClass: "rule-wrapper" }, [
                      _c(
                        "b",
                        {
                          staticClass: "rule-header product-list-description",
                          on: {
                            click: function($event) {
                              return _vm.toggleRules(i)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n          " + _vm._s(rule.name) + "\n          "
                          ),
                          _c("div", { staticClass: "arrow-indicator close" })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "rule-content",
                          staticStyle: { display: "none" }
                        },
                        _vm._l(rule.data, function(d) {
                          return _c("pre", [_vm._v(_vm._s(d))])
                        }),
                        0
                      )
                    ])
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "close-button",
                  attrs: {
                    "aria-label": "Popup schließen",
                    "data-close": "",
                    type: "button"
                  }
                },
                [_vm._v("Fenster schließen ( x )")]
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }